import axiosInstance from "../config/AxiosConfig";
import { BaseResponse } from "domain/payload/response/BaseResponseDto";
import { ProfileDataResp } from "domain/payload/response/profile/ProfileDataResp";
import { ChangePasswordResp } from "domain/payload/response/profile/ChangePasswordResp";

const ProfileService = () => {
  const getProfile = async (token: string): Promise<BaseResponse<ProfileDataResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/profile/get-profile`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
      return response.data;
    } catch (error: any) {
      throw (
        error.response?.data?.message ||
        error.message ||
        "Gagal mengambil profil"
      );
    }
  };

  const updateProfile = async (
    token: string,
    name: string,
    tagLine: string,
    profilePicture?: File | null
  ): Promise<BaseResponse<ProfileDataResp>> => {
    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("tagLine", tagLine);
      if (profilePicture) formData.append("profilePicture", profilePicture);

      const response = await axiosInstance.put(
        `/v1/legacy/cms/profile/update`,
        formData,
        {
          headers: { 
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`
          },
        }
      );

      return response.data;
    } catch (error: any) {
      throw (
        error.response?.data?.message ||
        error.message ||
        "Gagal memperbarui profil"
      );
    }
  };

  const changePassword = async (
    token: string,
    oldPassword: string,
    newPassword: string,
    confirmPassword: string
  ): Promise<BaseResponse<ChangePasswordResp>> => {
    try {
      const body = { oldPassword, newPassword, confirmPassword };
      const response = await axiosInstance.post(
        `/v1/legacy/cms/auth/change-password`,
        body,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error: any) {
      throw (
        error.response?.data?.message ||
        error.message ||
        "Gagal mengubah password"
      );
    }
  };

  return { getProfile, updateProfile, changePassword };
};

export default ProfileService;